import DataService from '../../common/services/dataService';
import HttpService from '../../Dashboard/duck/HttpService';
import StimService from "../../Stims/StimService";

import Creators from './actions';

const fetchStimsBegin = Creators.fetchStimsBegin;
const fetchStimsSuccess = Creators.fetchStimsSuccess;
const fetchStimsError = Creators.fetchStimsError;
const setStimFilters = Creators.setStimFilter;
const getTypesBegin = Creators.getTypesBegin;
const getTypesSuccess = Creators.getTypesSuccess;
const setStimTypeFilter = Creators.setStimTypeFilter;
const setMediaFilter = Creators.setMediaFilter;
const sortByAscendingOrder = Creators.sortByAscendingOrder;
const sortByDecendingOrder = Creators.sortByDecendingOrder;

const getStimsData = (stimsPerPage, pageNum, orderBy, filterName, filterMediaId, filterStimType,  filterBrandId,filterStudyId = null,  clutter = null,  filterCountryId = 0, filterLanguageId = 0, filterAdTypeId = 0,filterImportant = "all",  filterCreatedFrom = null, filterCreatedTo = null  ) => {

  return async dispatch => {
    dispatch(fetchStimsBegin());
    try {
      let data = {
        results_per_page: stimsPerPage,
        page_num: pageNum,
        order_by: orderBy,
        filter_name: filterName,
        filter_media_id: parseInt(filterMediaId),
        filter_stimtype: filterStimType,
        filter_study_id: filterStudyId,
        filter_brand_id: filterBrandId,
        filter_country_id: parseInt(filterCountryId || 0),
        filter_language_id: parseInt(filterLanguageId || 0),
        filter_ad_type_id: parseInt(filterAdTypeId || 0),
        

      };
      const toYMD = (d) => {
        if (!d) return null;
        const dt = new Date(d);
        if (Number.isNaN(dt.getTime())) return null;
        const yyyy = dt.getFullYear();
        const mm = String(dt.getMonth() + 1).padStart(2, "0");
        const dd = String(dt.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };

    const createdFrom = toYMD(filterCreatedFrom);
    const createdTo = toYMD(filterCreatedTo);

    if (createdFrom) data.filter_created_from = createdFrom;
    if (createdTo) data.filter_created_to = createdTo;

    const normalizeBoolString = (v) => {
      if (v === true) return "true";
      if (v === false) return "false";

      if (typeof v === "string") {
        const s = v.trim().toLowerCase();
        if (s === "true" || s === "false") return s;
      }

      // if it's null/undefined/"all"/anything else => don't send filter
      return null;
    };

    const clutterValue = normalizeBoolString(clutter);

    if (clutterValue !== null) {
      data.filter_clutter = clutterValue; 
    } else {
      delete data.filter_clutter;
    }

    delete data.clutter;

      const res = await DataService.fetchStimsData(data);
      dispatch(fetchStimsSuccess(res.data));
    }
    catch (err) {
      dispatch(fetchStimsError(err));
      throw (err);
    }
  };
};

const getTypes = () => {

  return async dispatch => {
    dispatch(getTypesBegin());

    const envResults = await HttpService.getEnvironmentList();
    const mediaResults = await HttpService.getMediaList();
    const stimTypesResults = await HttpService.getStimTypesList();
    const languageResults = await HttpService.getLanguageList();
    const locationResults = await HttpService.getLocationsList();
    const questionResults = await HttpService.getQuestionsList();
    const brandResults = await StimService.getBrands();

    dispatch(getTypesSuccess(envResults.data, mediaResults.data, stimTypesResults.data, languageResults.data, locationResults.data, questionResults.data, brandResults.data));
  };
};

const setStimFilter = (e, type) => {
  return dispatch => {
    if (type === 'media') {
      dispatch(setMediaFilter(e));
    } else if (type === 'stimType') {
      dispatch(setStimTypeFilter(e));
    } else {
      dispatch(setStimFilters(e, type));
    }
  };
};

const sortAscendingData = (item, type) => {
  if (type === 'DECENDING') {
    return dispatch => {
      dispatch(sortByDecendingOrder(item, type));
    };
  } else {
    return dispatch => {
      dispatch(sortByAscendingOrder(item, type));
    };
  }
};

export default {
  getStimsData,
  getTypes,
  setStimFilter,
  sortAscendingData,
  fetchStimsBegin,
};